import {useEffect, useRef, useState} from "react";
import {chunkedArray} from "common/utils";

const CHUNK_SIZE = 20;

const useItemFetcher = (fetchNext, groupSize = 1) => {

    const metaInfoRef = useRef({
        requestedPages: [],
        cursors: [],
    });

    const itemFetchInfoRef = useRef({
        items: [],
        storage: {},
        rowCount: undefined,
        finalRowCount: undefined,
    });

    const [itemFetchInfoState, setItemFetchInfoState] = useState(itemFetchInfoRef.current);

    const reset = () => {
        metaInfoRef.current = {
            requestedPages: [],
            cursors: [],
        };
        itemFetchInfoRef.current = {
            items: [],
            storage: {},
            rowCount: undefined,
            finalRowCount: undefined,
        };
        setItemFetchInfoState(itemFetchInfoRef.current);
    };


    const loadMoreRows = async (startIndex, stopIndex) => {
        console.log('loadMoreRows', )
        const startPage = Math.floor(startIndex / CHUNK_SIZE);
        const stopPage = Math.floor(stopIndex / CHUNK_SIZE);
        const metaInfo = metaInfoRef.current;
        const requestedPages = metaInfo.requestedPages;
        const itemFetchInfo = itemFetchInfoRef.current;

        const newlyRequestedPages = [];
        for (let page = startPage; page <= stopPage; page++) {
            if (!requestedPages.includes(page)) {
                newlyRequestedPages.push(page);
            }
        }
        console.log('useItemFetcher loadMoreRows', startIndex, stopIndex, newlyRequestedPages, metaInfo, itemFetchInfo);

        for (let page of newlyRequestedPages) {
            const cursor = metaInfo.cursors[page];
            if (page !== 0 && !cursor) {
                // console.log('loadMoreRows continue', query, page, scrollInfo, cursor);
                continue;
            }
            requestedPages.push(page)
            const res = await fetchNext(cursor, CHUNK_SIZE);
            const {nextItems, nextCursor} = res;
            try {
                console.log('fetchNext', nextItems, nextCursor);
                if (nextItems) {
                    if (nextItems.length > 0) {
                        metaInfo.cursors[page + 1] = nextCursor;
                        itemFetchInfo.items[page * CHUNK_SIZE] = nextItems[0];
                        itemFetchInfo.items.splice(page * CHUNK_SIZE, nextItems.length, ...nextItems);
                        const finalItems = itemFetchInfo.items.filter((item) => Boolean(item)).map((item, i) => {
                            if (item) {
                                item.index = i;
                            }
                            return item;
                        });
                        console.log('finalItems', finalItems);
                        const chunkedFinalItems = chunkedArray(finalItems.filter((item) => Boolean(item)), groupSize);
                        itemFetchInfoRef.current = {
                            items: finalItems,
                            storage: Object.assign(
                                {}, ...chunkedFinalItems.map(
                                    (item, i) => ({[Math.floor(item[0].index / groupSize)]: groupSize === 1 ? item[0] : item})
                                )
                            ),
                            rowCount: chunkedFinalItems.length + (nextCursor ? CHUNK_SIZE : 0),
                            finalRowCount: nextCursor ? undefined : chunkedFinalItems.length,
                        };
                        console.log('itemFetchInfoRef.current', itemFetchInfoRef.current);
                    } else {
                        itemFetchInfoRef.current = {
                            items: itemFetchInfo.items,
                            storage: itemFetchInfo.storage,
                            rowCount: itemFetchInfo.rowCount === undefined ? 0 : itemFetchInfo.rowCount,
                            finalRowCount: itemFetchInfo.finalRowCount === undefined ? 0 : itemFetchInfo.finalRowCount,
                        };
                    }
                } else {
                    console.error(res);
                }
            } catch (e) {
                console.error(e);
            }
        }
        setItemFetchInfoState(itemFetchInfoRef.current);
    };

    useEffect(() => {
        console.log('itemFetchInfoState 222', itemFetchInfoState);
    }, []);

    return {itemFetchInfoState, loadMoreRows, reset};
};

export default useItemFetcher;
